import { render, staticRenderFns } from "./DCIRegistration.vue?vue&type=template&id=7ac3b6a4&scoped=true"
import script from "./DCIRegistration.vue?vue&type=script&lang=js"
export * from "./DCIRegistration.vue?vue&type=script&lang=js"
import style0 from "./DCIRegistration.vue?vue&type=style&index=0&id=7ac3b6a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac3b6a4",
  null
  
)

export default component.exports